module.exports = __webpack_public_path__ + "img/healthProMobile2-EN.aaf641e0.png";